module.exports = __webpack_public_path__ + "img/img-auth-sideimg2.3d0c96f6.png";